module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/* Html5Player Banner */
(function (fox, $) {
	"use strict";

	fox.registerWidget('Html5Player_Banner', {
		configure: function (options) {
			this.registerOptions('', {
				manualRender: true
			});

			this.callParent('configure', arguments);
		},

		running: function() {
			this.setBanner();

			this.callParent('running', arguments);
		},

		activate: function() {
			this.setBanner();

			this.callParent('activate', arguments);
		},

		setBanner: function() {}

	}, 'Widget');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/htmlplayer/widget/banner.js
// module id = 33
// module chunks = 4